import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import AccountManagementContainer from 'app/containers/HumanResources/AccountManagement'

const AccountManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.account_management)}</PageTitle>
      <AccountManagementContainer />
    </>
  )
}
const AccountManagementPage = memo(AccountManagementPageCpn, isEqual)

export default AccountManagementPage
